import { ReactNode } from "react";

import MetaInfoListItem from "components/MetaInfoList/Item";
import { Stack } from "components/icons/generated";
import Badge from "ds/components/Badge";
import Box from "ds/components/Box";
import Link from "ds/components/Link";
import TileContent from "ds/components/Tile/Content";
import TileWrapper from "ds/components/Tile/Wrapper";
import Typography from "ds/components/Typography";
import { AnalyticsPageDashboard } from "hooks/useAnalytics/pages/dashboard";
import { RunState, StackTile } from "types/generated";
import RunStateBadge from "components/Run/elements/StateBadge";

import styles from "./styles.module.css";

type DashboardWidgetsRunTileProps = {
  id: string;
  title: string;
  state?: RunState;
  stackTile: StackTile;
  caption?: ReactNode;
  needsApproval?: boolean;
  analyticsTitle?: string;
  approval?: boolean;
};

const DashboardWidgetsRunTile = ({
  id,
  title,
  caption,
  state,
  stackTile,
  needsApproval = false,
  analyticsTitle,
  approval,
}: DashboardWidgetsRunTileProps) => {
  return (
    <TileWrapper>
      <TileContent>
        <Box justify="between" align="center" gap="medium" fullWidth>
          <Box grow="1">
            <Box direction="column" gap="medium" fullWidth>
              <Box fullWidth>
                <Link
                  analyticsTitle={`${analyticsTitle} - Run Clicked`}
                  analyticsPage={AnalyticsPageDashboard.Dashboard}
                  analyticsProps={{
                    stackName: stackTile.name,
                    runState: state,
                  }}
                  href={`/stack/${stackTile.slug}/run/${id}`}
                  variant="secondary"
                  className={styles.title}
                >
                  {title}
                </Link>
              </Box>

              {caption}
            </Box>
          </Box>

          <Box className={styles.metaWrapper}>
            <Box
              direction="column"
              align="end"
              gap="medium"
              fullWidth
              className={styles.metaContent}
            >
              {approval === true && (
                <Badge
                  className={styles.badge}
                  textEllipsis
                  text="Approved"
                  variant="green"
                  type="strong"
                />
              )}

              {approval === false && (
                <Badge
                  className={styles.badge}
                  textEllipsis
                  text="Rejected"
                  variant="red"
                  type="strong"
                />
              )}

              {state && <RunStateBadge className={styles.badge} textEllipsis state={state} />}

              {needsApproval && (
                <Box gap="small" align="center">
                  <div className={styles.dot} />
                  <Typography color="primary" tag="span" variant="p-body3">
                    Needs approval
                  </Typography>
                </Box>
              )}

              <Box align="end" gap="medium" fullWidth>
                <MetaInfoListItem
                  fullWidth
                  analyticsTitle={`${analyticsTitle} - Stack Clicked`}
                  analyticsPage={AnalyticsPageDashboard.Dashboard}
                  analyticsProps={{
                    stackName: stackTile.name,
                    runState: state,
                  }}
                  to={`/stack/${stackTile.slug}`}
                  linkText={stackTile.name}
                  icon={Stack}
                  variant="p-body3"
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </TileContent>
    </TileWrapper>
  );
};

export default DashboardWidgetsRunTile;
